/**
  * @class meleActorTime
  * @description
  *
  * # Purpose
  * Implements `<mele-actor-time>` custom web element for showing time in <mele-channel>
  */

import meleActor from 'meleActor'

const PROPERTIES = _.extend({}, {
  ets: { description: 'event timestamp - current playback time in miliseconds', type: 'integer' },
}, meleActor._properties)

export default class meleActorTime extends meleActor {
  init() {
    super.init()
    this.classList.add('indicator')
  }

  async etsChanged(ets) {
    if(ets > 0) {
      const [d, t] = _.usec2ymdhmsms(ets).split(' ')
      this.innerHTML = `<span class="title">${d}</span><span class="subtitle">${t}</span>`
    }else {
      this.innerHTML = ''
    }
  } // etsChanged
} // class meleActorTime

meleActorTime._properties = PROPERTIES
meleActorTime.observedAttributes = _.keys(PROPERTIES)
window.customElements.define('mele-actor-time', meleActorTime)
